import '../../index.css';
import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import firebase from '../../helpers/firebase';
import styles from './StudentFeedback.module.css';
import config from '../../helpers/config.js';
import load from '../../helpers/spreadsheet.js';
import {
  Chart,
  Legend,
  PieSeries,
} from '@devexpress/dx-react-chart-material-ui';
import { Animation } from '@devexpress/dx-react-chart';
import { withStyles } from '@material-ui/core';
import DateRangePicker from '@wojtekmaj/react-daterange-picker';
import Loader from '../Loader';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import { Helmet } from 'react-helmet';
const yesterdayDate = new Date();
yesterdayDate.setDate(yesterdayDate.getDate() - 1);

export default class StudentFeedback extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dateRange: [yesterdayDate, yesterdayDate],
      error: null,
      chart_data: null,
      feedback_dates: [],
      displayLoadingDiv: true,
      displayAllElse: false,
      specific_item: null,
      reason: null,
    };
  }

  componentDidMount() {
    this.getGraphLinks();
  }

  initClient = () => {
    window.gapi.client
      .init({
        apiKey: config.apiKey,
        discoveryDocs: config.discoveryDocs,
      })
      .then(() => {
        load(this.onLoad, this.state.spreadsheetId);
      });
  };

  onLoad = (data, error) => {
    if (data) {
      this.setState({ chart_data: data });
      this.setState({ displayLoadingDiv: false, displayAllElse: true });
    } else {
      this.setState({ error });
      this.setState({ displayLoadingDiv: false, displayAllElse: true });
    }
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (
      this.props.campus !== prevProps.campus ||
      this.props.diningHall !== prevProps.diningHall
    ) {
      this.getGraphLinks();
    }
    if (prevState.spreadsheetId !== this.state.spreadsheetId) {
      window.gapi.load('client', this.initClient);
    }
  }

  getGraphLinks = async () => {
    if (!this.props.campus) {
      return;
    }
    const doc = await firebase
      .firestore()
      .collection('campus')
      .doc(this.props.campus)
      .collection('halls')
      .doc(this.props.diningHall)
      .get();
    this.setState({
      spreadsheetId: doc.data()['spreadsheetId'],
      spreadsheetLink: doc.data()['spreadsheetLink'],
      studentLink: doc.data()['studentLink'],
    });
  };

  onDateRangeChange = (date) => {
    this.setState({ dateRange: date });
  };

  dateLastWeek = () => {
    var today = new Date();
    var lastWeek = new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate() - 7
    );
    this.setState({ dateRange: [lastWeek, today] });
  };

  dateLastMonth = () => {
    var today = new Date();
    var lastMonth = new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate() - 30
    );
    this.setState({ dateRange: [lastMonth, today] });
  };

  dateLastYear = () => {
    var today = new Date();
    var lastYear = new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate() - 365
    );
    this.setState({ dateRange: [lastYear, today] });
  };

  zip_chart_data(dict) {
    let zipped = [[]];
    let feedback_dates = [];
    if (dict != null) {
      for (let i = 0; i < dict['data'].length; i++) {
        for (let j = 0; j < dict['data'][i].length; j++) {
          if (j === 0) {
            feedback_dates.push(dict['data'][i][j]);
          }
          if (!zipped[j]) {
            zipped[j] = [];
          }
          zipped[j].push(dict['data'][i][j]);
        }
      }
      if (
        JSON.stringify(this.state.feedback_dates) !==
        JSON.stringify(feedback_dates)
      ) {
        this.setState({ feedback_dates: feedback_dates });
      }
      return zipped;
    }
    return [];
  }

  get_item_counts(dict) {
    if (dict) {
      let feedback_dates = this.state.feedback_dates;
      let item_counts = [];
      for (let i = 0; i < dict.length; i++) {
        let item_count_dict = {};
        for (let j = 1; j < dict[i].length; j++) {
          let split_values = dict[i][j].split(', ');
          let curr_date_to_iterate = new Date(feedback_dates[j]);
          for (let k = 0; k < split_values.length; k++) {
            if (
              curr_date_to_iterate >= this.state.dateRange[0] &&
              curr_date_to_iterate <= this.state.dateRange[1]
            ) {
              if (!(split_values[k] in item_count_dict)) {
                item_count_dict[split_values[k]] = 1;
              } else {
                item_count_dict[split_values[k]] += 1;
              }
            }
          }
        }
        item_counts.push(item_count_dict);
      }
      return item_counts;
    }
    return [];
  }

  get_item_counts_by_item(dict, item) {
    if (dict && item) {
      let feedback_dates = this.state.feedback_dates;
      let item_counts = [];

      let reasons_dict = {};
      for (let i = 0; i < dict.length; i++) {
        if (i === 1) {
          for (let j = 1; j < dict[i].length; j++) {
            let split_items = dict[i][j].split(', ');
            let split_reasons = dict[2][j].split(', ');
            let curr_date_to_iterate = new Date(feedback_dates[j]);

            if (
              curr_date_to_iterate >= this.state.dateRange[0] &&
              curr_date_to_iterate <= this.state.dateRange[1] &&
              split_items.includes(item)
            ) {
              for (let k = 0; k < split_reasons.length; k++) {
                if (!(split_reasons[k] in reasons_dict)) {
                  reasons_dict[split_reasons[k]] = 1;
                } else {
                  reasons_dict[split_reasons[k]] += 1;
                }
              }
            }
          }
        }
      }
      item_counts.push(reasons_dict);
      return item_counts;
    }
    return [{}];
  }

  get_item_counts_by_reason(dict, reason) {
    if (dict && reason) {
      let feedback_dates = this.state.feedback_dates;
      let item_counts = [];

      let items_dict = {};
      for (let i = 0; i < dict.length; i++) {
        if (i === 2) {
          for (let j = 1; j < dict[i].length; j++) {
            let split_reasons = dict[i][j].split(', ');
            let split_items = dict[1][j].split(', ');
            let curr_date_to_iterate = new Date(feedback_dates[j]);

            if (
              curr_date_to_iterate >= this.state.dateRange[0] &&
              curr_date_to_iterate <= this.state.dateRange[1] &&
              split_reasons.includes(reason)
            ) {
              for (let k = 0; k < split_items.length; k++) {
                if (!(split_items[k] in items_dict)) {
                  items_dict[split_items[k]] = 1;
                } else {
                  items_dict[split_items[k]] += 1;
                }
              }
            }
          }
        }
      }
      item_counts.push(items_dict);
      return item_counts;
    }
    return [{}];
  }

  itemSelect = (item) => {
    this.setState({ specific_item: item.target.value });
  };

  reasonSelect = (item) => {
    this.setState({ reason: item.target.value });
  };

  render() {
    const legendStyles = () => ({
      pieRoot: {
        minHeight: '150px',
        maxHeight: '150px',
        minWidth: '150px',
        maxWidth: '150px',
        overflow: 'auto',
      },
    });
    const pieLegendRootBase = ({ classes, ...restProps }) => (
      <Legend.Root {...restProps} className={classes.pieRoot} />
    );
    const pieRoot = withStyles(legendStyles, { name: 'LegendRoot' })(
      pieLegendRootBase
    );
    let zipped_data = this.zip_chart_data(this.state.chart_data);
    let item_counts = this.get_item_counts(zipped_data).slice(1);
    let item_counts_by_item = this.get_item_counts_by_item(
      zipped_data,
      this.state.specific_item
    ).slice(0);
    let item_counts_by_reason = this.get_item_counts_by_reason(
      zipped_data,
      this.state.reason
    ).slice(0);
    const displayAllElse = this.state.displayAllElse ? {} : { display: 'none' };

    const pieData = item_counts.map((data, index) => {
      const pie = Object.keys(data).map((item) => {
        return {
          area: data[item],
          food: item,
        };
      });
      return (
        <div className={styles.chartColumn}>
          <h2 className={styles.chartColumnName}>
            {zipped_data[index + 1][0]}
          </h2>
          <Chart data={pie} height={200}>
            <PieSeries
              valueField="area"
              argumentField="food"
              rootComponent={pieRoot}
            />
            <Legend rootComponent={pieRoot} />
            <Animation />
          </Chart>
        </div>
      );
    });

    let item_counts2 = [item_counts_by_item[0], item_counts_by_reason[0]];

    const pieData2 = item_counts2.map((data, index) => {
      const pie2 = Object.keys(data).map((item) => {
        return {
          area: data[item],
          reason: item,
        };
      });
      return (
        <div className={styles.chartColumn}>
          <h2 className={styles.chartColumnName}>
            {
              [
                "Reason item wasn't finished",
                "Food that wasn't finished for reason",
              ][index]
            }
          </h2>
          <Chart data={pie2} height={200}>
            <PieSeries
              valueField="area"
              argumentField="reason"
              rootComponent={pieRoot}
            />
            <Legend rootComponent={pieRoot} />
            <Animation />
          </Chart>
        </div>
      );
    });

    return (
      <div
        style={{
          justifyContent: 'center',
          margin: 'auto',
        }}
      >
        <Helmet>
          <meta
            name="description"
            content="DeWaste is the easiest way to quickly and reliably reduce food waste. Using image analysis, we can give you accurate wastage data instantly."
          />

          <meta
            itemProp="name"
            content="DeWaste | Food Waste Analysis for all dining institutions"
          />
          <meta
            itemProp="description"
            content="DeWaste is the easiest way to quickly and reliably reduce food waste. Using image analysis, we can give you accurate wastage data instantly."
          />
          <meta itemProp="image" content="https://de-waste.com/logo.png" />

          <meta property="og:image" content="https://de-waste.com/logo.png" />
          <meta property="og:type" content="website" />
          <meta property="og:title" content="DeWaste" />
          <meta
            property="og:description"
            content="DeWaste is the easiest way to quickly and reliably reduce food waste. Using image analysis, we can give you accurate wastage data instantly."
          />
          <meta property="og:site_name" content="DeWaste" />
          <meta property="og:url" content="https://de-waste.com" />

          <meta name="twitter:card" content="summary" />
          <meta name="twitter:image" content="https://de-waste.com/logo.png" />
          <meta name="twitter:title" content="DeWaste" />
          <meta
            name="twitter:description"
            content="DeWaste is the easiest way to quickly and reliably reduce food waste. Using image analysis, we can give you accurate wastage data instantly."
          />
        </Helmet>

        <Loader display={this.state.displayLoadingDiv} />
        <div className={styles.datePickerContainer} style={displayAllElse}>
          <DateRangePicker
            onChange={this.onDateRangeChange}
            value={this.state.dateRange}
          />
        </div>

        <div
          className={styles.dateRangeButtonsContainer}
          style={displayAllElse}
        >
          <Button
            className={styles.dateRangeButton}
            variant="contained"
            onClick={this.dateLastWeek}
          >
            Last Week
          </Button>
          <Button
            className={styles.dateRangeButton}
            variant="contained"
            onClick={this.dateLastMonth}
          >
            Last Month
          </Button>
          <Button
            className={styles.dateRangeButton}
            variant="contained"
            onClick={this.dateLastYear}
          >
            Last Year
          </Button>
        </div>

        <Button
          variant="outlined"
          className={styles.spreadsheetButton}
          href={this.state.spreadsheetLink}
          target={'_'}
          style={displayAllElse}
        >
          Go to Spreadsheet
        </Button>

        <br />
        <br />
        <div className={styles.row}>{pieData}</div>

        <div className={styles.row} style={{ paddingTop: '75px' }}>
          <div className={styles.itemDropdown}>
            <FormControl variant="outlined" style={displayAllElse}>
              <InputLabel htmlFor="outlined-age-simple">Item</InputLabel>
              <Select
                value={this.state.specific_item}
                className={styles.itemDropdownSelect}
                onChange={this.itemSelect}
                input={<OutlinedInput labelWidth={300} name="Item" />}
              >
                {item_counts[0] ? (
                  Object.keys(item_counts[0]).map((item) => {
                    return <MenuItem value={item}>{item}</MenuItem>;
                  })
                ) : (
                  <MenuItem />
                )}
              </Select>
            </FormControl>
          </div>

          <div className={styles.itemDropdown}>
            <FormControl
              variant="outlined"
              className={styles.itemDropdown}
              style={displayAllElse}
            >
              <InputLabel
                htmlFor="outlined-age-simple"
                className={styles.itemDropdown}
              >
                Reason
              </InputLabel>
              <Select
                value={this.state.reason}
                className={styles.itemDropdownSelect}
                onChange={this.reasonSelect}
                input={<OutlinedInput labelWidth={300} name="Item" />}
              >
                {item_counts[1] ? (
                  Object.keys(item_counts[1]).map((item) => {
                    return <MenuItem value={item}>{item}</MenuItem>;
                  })
                ) : (
                  <MenuItem />
                )}
              </Select>
            </FormControl>
          </div>
        </div>

        <div className={styles.row}>{pieData2}</div>

        <span className={styles.studentLink} style={displayAllElse}>
          Please provide this link to students for feedback:{' '}
          <a
            href={this.state.studentLink}
            target="_blank"
            rel="noopener noreferrer"
          >
            {this.state.studentLink}
          </a>
        </span>
        <br />
        <br />
        <br />
        <br />
      </div>
    );
  }
}
